var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElSalvador(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 0.0107422C9.65652 0.0107422 4.17552 3.7023 1.58752 9.05424H30.4122C27.8243 3.7023 22.3432 0.0107422 15.9999 0.0107422V0.0107422Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 32.0105C22.3432 32.0105 27.8243 28.319 30.4123 22.967H1.58752C4.17552 28.319 9.65652 32.0105 15.9999 32.0105Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7867 16.7065L15.9999 11.1413L19.213 16.7065H12.7867Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1739 18.5441L16 20.6311L11.826 18.5441V15.7616H20.1739V18.5441Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9351 11.3797L18.4594 12.8554C19.0889 13.4848 19.4783 14.3544 19.4783 15.3149C19.4783 17.2359 17.921 18.7932 16 18.7932C14.0791 18.7932 12.5218 17.2358 12.5218 15.3149C12.5218 14.3544 12.9111 13.4848 13.5406 12.8554L12.0649 11.3797C11.0577 12.3867 10.4348 13.778 10.4348 15.3149C10.4348 18.3885 12.9264 20.8801 16 20.8801C19.0736 20.8801 21.5652 18.3885 21.5652 15.3149C21.5651 13.778 20.9423 12.3867 19.9351 11.3797V11.3797Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElSalvador);
export default __webpack_public_path__ + "static/media/el-salvador.fa6b5295.svg";
export { ForwardRef as ReactComponent };